import React, { useState, useEffect, useRef } from 'react';
import './JobCard.css';
import menu from '../../../assets/images/three-line-menu.svg';
import menuClose from '../../../assets/images/three-line-close.svg';
import CompanyLogo from '../../../assets/images/company-logo.png';
import { useNavigate } from "react-router-dom";
import { jwtDecode } from 'jwt-decode';
import axios from 'axios';
import { API_BASE_URL } from '../../../config';
import JobReview from '../../JobReview/JobReview';
import showToast from '../../../components/ShowToast';
import Loader from '../../../components/Loader';


const JobCard = ({ data, id }) =>
{

    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [isPopupOpen, setIsPopupOpen] = useState(false);
    const [reviewData, setReviewData] = useState(null);

    // Ref to detect outside clicks
    const menuRef = useRef();

    const toggleMenu = (e) =>
    {
        if (isMenuOpen)
        {
            setIsMenuOpen(false);
        } else
        {
            setIsMenuOpen(true);
        }
    };

    const openEditJob = () =>
    {
        console.log("Navigate to job detail with ID:", id);
        navigate("/job-detail", { state: { jobId: id, duplicate: 0 } });
    }


    const duplicateJob = () =>
    {
        console.log("Navigate to job detail with ID:", 0);
        navigate("/job-detail", { state: { jobId: id, duplicate: 1 } });
    }

    const handleWriteReviewClick = async (e, data) =>
    {
        e.stopPropagation();
        setLoading(true);

        setReviewData(null);
        setIsPopupOpen(false);

        try
        {
            const token = localStorage.getItem('token');
            const userId = jwtDecode(token)?.nameid;
            const businessId = data?.assignedBusinessId;

            if (businessId && userId)
            {
                const reviewResponse = await axios.get(
                    `${API_BASE_URL}/api/BusinessReview/viewReviewForEdit?businessId=${businessId}&userId=${userId}`
                );

                if (reviewResponse.status === 200)
                {
                    const reviewData = reviewResponse.data;
                    setReviewData(reviewData);
                    setIsPopupOpen(true);
                }
            }
        } catch (error)
        {
            console.error("Error in handleWriteReviewClick:", error);
            showToast(error.message || "Something went wrong");
        } finally
        {
            setLoading(false);
        }
    };


    useEffect(() =>
    {
        const handleClickOutside = (event) =>
        {
            if (menuRef.current && !menuRef.current.contains(event.target))
            {
                setIsMenuOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () =>
        {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [menuRef]);

    return (
        <div className='job-card'>
            {loading ? <Loader /> : null}
            <div className='card_title position-relative gap-1'>
                <div className='d-flex align-items-center'>
                    <img src={CompanyLogo} className="comapny-logo" ref={menuRef} alt='Menu' />
                    <div className='d-flex align-items-center'>
                        <h3 className='card_title-p'>{data.name}</h3>
                        <p className='card_title-l'>{data.location} </p>
                    </div>
                </div>
                <img src={isMenuOpen ? menuClose : menu} className="menu-container" ref={menuRef} alt='Menu' onClick={toggleMenu} />
                {isMenuOpen && (
                    <ul className="menu-list" style={{ right: '-170px' }} ref={menuRef}>
                        <li onClick={openEditJob}>View / Edit Job</li>
                        <li onClick={duplicateJob}>Duplicate Job</li>
                        {data.assignedBusinessId ? (<li type='button' onClick={(e) => handleWriteReviewClick(e, data)}>Review Job</li>) : null}
                    </ul>
                )}
            </div>

            <div className='card_item'>
                <p className='job-card-description'>{data.description.length > 40 ? `${data.description.slice(0, 40)}...` : data.description}</p>

                <div className='job-status-quote'>
                    <p >Status :
                        <span className='quote-color pending-status'>
                            {data.jobStatus}
                        </span>
                    </p>
                    <p>Quotes: {data.quoteCount}</p>
                </div>

                <div>Assigned to {data.businessName}</div>


            </div>
            <div className='card_button'>
                <button className="btn theme_btn" onClick={openEditJob}>
                    View this Job
                </button>
            </div>
            {isPopupOpen && <JobReview data={reviewData} jobData={data} isPopup={isPopupOpen} />}
        </div>
    )
}

export default JobCard
